import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";

import { Header } from "../../../components/header";
import { SendIcon } from "../../../components/icons";

import { useCategory } from "../hooks";

type ICategoryParams = {
  id: string;
};

export const Category: React.FC = () => {
  const { id } = useParams<ICategoryParams>();
  const navigate = useNavigate();
  useEffect(() => {
    if (!id) {
      navigate("/categoriess");
    }
  }, []);

  const { data, loading, refetch } = useCategory(+id!);

  return (
    <>
      <Header
        title={"Category"}
        subtitle={data?.category?.result?.id ?? ""}
        buttons={[
          {
            actionText: "Modifier",
            bgColor: "indigo",
            textColor: "white",
            link: `/category/${data?.category?.result?.id}/update`,
            icon: <SendIcon />,
          },
        ]}
      />

      <div className="main-container">
        <section className="section">
          <div className="element">
            <div className="card">{data?.category?.result?.name}</div>
          </div>

          <div className="element">
            <div className="card"></div>
          </div>
        </section>
      </div>
    </>
  );
};
